import Aos from "aos";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "./index.scss";

function index() {
  useEffect(() => {
    // document.title = "Terms and Conditions | Galaxy Gemological Institute";
    window.scrollTo(0, 0);
  }, []);
  Aos.init({
    delay: 500,
    once: true,
  });
  return (
    <div>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ggilab.com/laboratory/terms-and-conditions"
        />
        <title>Lab Terms & Conditions - Galaxy Gemological Institute</title>
        <meta
          name="description"
          content="Read the comprehensive terms and conditions of Galaxy Gemological Institute's laboratory services. We ensure transparency and quality in gemstone assessments."
        />
      </Helmet>
      {/* <div className="Terms">
        <img
        alt="Terms_English_vop3kv.webp"
        src={
          "https://res.cloudinary.com/ggi/image/upload/v1724390301/Terms_Condition_page-0001_GGI_bbhtv5.jpg"
          }
          data-aos="flip-left"
          />
          <img
          alt="Terms_Urdu_wqg9an.webp"
          src={
            "https://res.cloudinary.com/ggi/image/upload/v1637903441/Terms_Urdu_wqg9an.webp"
            }
            data-aos="flip-right"
            /> 
            </div> */}
      <div className="Terms" >
        <div class="container">
          <h1 style={{ margin: "80px", marginLeft: "0px" }}>Terms And Conditions</h1>
          <h3 style={{ margin: "10px", marginLeft: "0px" }}>Important Information and Limitations on the Use of Galaxy Gemological Institute (GGI) Reports</h3>
          <div class="column">
            <p>
              The following terms and conditions govern all gemstone identification and grading reports issued by Galaxy Gemological Institute (GGI), outlining the rights and obligations between GGI and its clients.
            </p>
            <p>
              All reports issued by GGI are printed on official paper and include an authorized signature and hologram. Corrections or alterations of any kind are not accepted. Reproduction of the reports, or of any GGI trademarks or service marks—whether in whole or in part—requires prior written consent from GGI.
            </p>
            <p>
              A GGI report does not constitute a guarantee, valuation, or appraisal. GGI makes no representations or warranties regarding the reports, the items described therein, or any inscriptions on those items. The report reflects only the characteristics of the item as determined by GGI using its techniques and equipment at the time of examination. Results from subsequent examinations may vary depending on factors such as timing, methods, examiner, or advancements in technology that could detect previously undetectable treatments or reversible changes. Any trademarks, service marks, logos, or inscriptions on the item—except for the GGI report number or GGI's own trademarks—are the sole responsibility of the client and should not be construed as determinations by GGI.
            </p>
          </div>
          <div class="column">
            <p>
              The GGI report includes gemstone identification through photographic images, descriptions, dimensions, and weight, along with an opinion on authenticity, treatments, origin, quality, and rarity. The actual appearance of the gemstone may differ from its photographic representation. Assessments of authenticity and origin are based on chemical and physical properties, internal characteristics (such as inclusions and growth patterns), and modern analytical tools including spectrometers. GGI's conclusions are drawn from comparisons with reference materials and published literature. The laboratory continuously updates its knowledge base and equipment as new data becomes available. In line with internationally accepted standards, not all possible treatments may be listed. The absence of a treatment reference does not confirm that no treatments were applied. Statements about treatments are based solely on GGI's findings at the time of examination.
            </p>
            <p>
              GGI does not currently possess advanced instruments such as LA-ICP-MS or SIMS, which are required to detect beryllium (Be) diffusion in corundum. Therefore, the presence or absence of beryllium treatment cannot be confirmed or ruled out in GGI reports. Clients requiring definitive detection are advised to consult laboratories equipped with such technology. Many laboratories also lack this capability.
            </p>
            <p>
              Statements regarding the quality and rarity of a gemstone are offered only upon request and reflect the laboratory's opinion based on practical experience. GGI reserves the right to decline issuing a report at any time.
            </p>
            <p>
              For items submitted for testing or grading, GGI bears no responsibility for any loss, damage, or misplacement of items not collected within 90 days of submission. Clients are strongly advised to collect their gemstones within 30 days. Failure to do so is at the client's own risk, and GGI shall not be held liable under any circumstances for items left unclaimed beyond the 90-day period.
            </p>
            <p>
              Unless explicitly agreed otherwise, clients agree not to hold GGI or its employees liable for any loss or damage to a gemstone during transportation, delivery, examination, or while in GGI's possession. This includes risks such as theft, robbery, natural disasters, and other uncontrollable events. Furthermore, GGI is not responsible for consequences arising from incomplete or inaccurate data in the report, including errors in dimensions, weight, typographical mistakes, or determinations regarding authenticity, origin, or treatments. Neither the client nor any third party to whom the report is shown or transferred may hold GGI liable for such issues.
            </p>
            <p>
              Reports issued by GGI are governed by the laws of the country in which the report is issued. They are admissible as evidence only within the jurisdiction of the city of issuance and may not be recognized in other jurisdictions. In the event of a dispute, clients agree to submit to binding arbitration in the city where the report was issued before pursuing any legal action. Any alteration, tampering, or modification of the gemstone or the report renders the report null and void
            </p>
            <p>
              All GGI reports can be verified online. GGI is not responsible for disputes arising from counterfeit or altered reports. Clients are encouraged to verify the authenticity of any report through GGI's official verification channels.
            </p>
            <p>
              In certain cases, a preliminary verbal opinion may be provided after a brief analysis. This verbal is informal, non-binding, and based on limited indicators. If the client opts for a verbal, GGI will contact them before proceeding with full analysis, offering the option to stop the process. The final report may differ from the initial verbal, and the full-service fee still applies. GGI may not be able to provide a verbal for every item, and clients are responsible for payment regardless of the verbal's completeness or accuracy.
            </p>
            <p>
              The Consultation Card is a preliminary, informal, and non-binding summary of the analysis, handwritten by a GGI employee and provided in person at OPT or fairs. It is not mailed or sent electronically. The Consultation Card offers limited information and does not substitute for the formal GGI Lab Report, which is the only fully reliable document. It does not undergo the same quality control process as formal reports, and its content may differ from the final report. Clients are strongly advised not to make irreversible decisions based solely on the Consultation Card.
            </p>
            <p>
              Clients should consult GGI's website for the most current terms and conditions, which are updated periodically
            </p>
          </div>
        </div>

        {/* <img
          alt="Terms_English_vop3kv.webp"
          src={
            "https://res.cloudinary.com/ggi/image/upload/v1724390638/Terms_Condition_page-0001_GGI_2.jpg_ewlays.png"
          }
          data-aos="flip-left"
        />

        {/* <img */}
        {/* alt="Terms_Urdu_wqg9an.webp"
          src={
            "https://res.cloudinary.com/ggi/image/upload/v1637903441/Terms_Urdu_wqg9an.webp"
          }
          data-aos="flip-right"
        /> */} */
      </div>
    </div>
  );
}

export default index;
